interface StatCardProps {
  label: string
  value: number
  /** The main figure on a blue card. Otherwise a white card */
  solid?: boolean
}

export default function StatCard({ label, value, solid = false }: StatCardProps) {
  if (solid) {
    return (
      <div className="flex flex-col gap-2.5 rounded-[14px] bg-dantzBlue px-[22px] py-5 text-white">
        <span className="text-[13px] font-medium text-appNavMuted">{label}</span>
        <span className="font-heading text-4xl font-semibold leading-none tabular-nums">{value}</span>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-2.5 rounded-[14px] border border-appLine bg-white px-[22px] py-5">
      <span className="text-[13px] font-medium text-appMuted">{label}</span>
      <span className="font-heading text-4xl font-semibold leading-none tabular-nums text-appInk">
        {value}
      </span>
    </div>
  )
}
